/* ===============================
    FB Popup - Utils
    ================================ */

function mountFbPopupTemplate() {
  if (document.querySelector(".pop_main1")) return;
  const tpl = document.getElementById("fb-ad-popup-template");
  if (!tpl) return;
  document.body.appendChild(tpl.content.cloneNode(true));
}

function popon2() {
  mountFbPopupTemplate();

  const $cover = jQuery(".window-cover1");
  const $popup = jQuery(".pop_main1");

  $cover.show();
  $popup.show();

  $popup
    .find(".pop_con")
    .css({ top: 0, opacity: 0 })
    .animate({ top: "50%", opacity: 1 });
  // 点击弹窗按钮复制内容
  var tanchuang_click_num = 0;
  jQuery(".pop_detail_button").each(function () {
    jQuery(this).on("click", function () {
      tanchuang_click_num += 1;
      if (tanchuang_click_num == 1) {
        if (jQuery(this).find(".pop_code_num")) {
          copyText(jQuery(this).find(".pop_code_num").text().trim());
        }
        jQuery(this).find("i").text("copied").addClass("copied");
        jQuery(this).find("svg").remove();
        jQuery(this).find(".pop_text").append(",");
        jQuery(this).append('<span class="popup_shop_now"> Shop Now>></span>');
      } else {
        jQuery(this).parent().parent().parent().hide();
        $(".pop_cover").hide();
      }
    });
  });

  window.copyText = function (text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      // Modern API
      navigator.clipboard
        .writeText(text)
        .then(() => console.log("复制成功"))
        .catch((err) => console.error("复制失败", err));
    } else {
      // Legacy fallback
      if (!document.body) {
        console.error("复制失败：document.body 尚未就绪");
        return; // 直接返回，避免报错
      }
      const input = document.createElement("input");
      input.value = text;
      input.style.position = "fixed";
      input.style.left = "-1000px";
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      console.log("复制成功（fallback）");
    }
  };
}

function closeFbPopup() {
  const $popup = jQuery(".pop_main1");
  const $cover = jQuery(".window-cover1");

  $popup.find(".pop_con").animate({ top: 0, opacity: 0 }, 200, function () {
    $popup.hide();
    $cover.hide();
  });
}

/* ===============================
             FB Popup - Events
          ================================ */

jQuery(document)
  .on("click", ".pop_main1 .window-cover_con-close", closeFbPopup)
  .on("click", ".window-cover1", closeFbPopup)
  .on("keydown", function (e) {
    if (e.key === "Escape" && jQuery(".pop_main1:visible").length) {
      closeFbPopup();
    }
  });

/* ===============================
             FB Popup - Trigger Logic
          ================================ */

function getUrlParam(name) {
  return new URLSearchParams(window.location.search).get(name);
}

function initFbPopupLogic() {
  const hasFbClid = getUrlParam("fbclid");

  if (hasFbClid && !location.pathname.includes("flash-sale")) {
    setTimeout(popon2, 90000);
  }
}

jQuery(initFbPopupLogic);
